import { Component } from '@angular/core';
import { UserDTO } from '../../../models/UserDTO.model';
import { DistributorsService } from 'src/app/services/distributors.service';
import { MasterDataDTO } from 'src/app/models/MasterDataDTO.model';
import { MasterdataRequestDTO } from 'src/app/models/MasterdataRequestDTO.model';
import { Alert } from 'src/app/shared/models/Alert';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ValidatePermissionsService } from 'src/app/shared/services/validate-permissions.service';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { emailValidator } from 'src/app/validators/email.validator';

import { CommonModule } from '@angular/common';
import { FormatPhoneUsDirective } from '../../../directives/format-phone-us.directive';
import { FormatEmailDirective } from '../../../directives/format-email.directive';

@Component({
    selector: 'app-create-distributors',
    templateUrl: './create-distributors.component.html',
    styleUrls: ['./create-distributors.component.css'],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        FormatPhoneUsDirective,
        FormatEmailDirective
    ]
})
export class CreateDistributorsComponent {
  form = new FormGroup({
    email: new FormControl('', [Validators.required, emailValidator()]),
  });

  get emailModel() {
    return this.form.get('email');
  }

  validMail: boolean = false;
  information: string = 'Create Distributor';
  distributorName: string = '';
  address: string = '';
  city: string = '';
  zipCode?: number = undefined;
  stateSelected: string = '';
  states: MasterDataDTO[] = [];
  contactNumber?: string = undefined;
  email: string = '';
  fieldsCompleted: boolean = false;
  masterdataRequestDTO: MasterdataRequestDTO = { idMaster: 1 };

  alert: Alert = {} as Alert;
  distributor: UserDTO = {} as UserDTO;

  constructor(
    private distributorsService: DistributorsService,
    private alertService: AlertService,
    public permissionsService: ValidatePermissionsService
  ) {}

  ngOnInit() {
    this.permissionsService.validateAccessLevels(MODULE_ID.Distributors);
    this.distributorsService.getMastersById(this.masterdataRequestDTO).subscribe(
      ({ StatusCode, Message, Data }) =>
        Data != null
          ? this.handleGetAllStatesSuccess(Data)
          : this.handleSaveError(StatusCode),
      () => {
        this.ErrorMessage();
        this.clearFields();
      }
    );
  }

  checkFields() {
    this.fieldsCompleted = !!(this.distributorName && this.contactNumber && this.email);
  }

  goBack() {
    window.location.href = '/home';
  }

  createDistributor() {
    this.distributor.userAddressLine1 = this.address;
    this.distributor.userPhone = this.contactNumber;
    this.distributor.userNames = this.distributorName;
    this.distributor.userMail = this.email;
    this.distributor.userState = this.stateSelected;
    this.distributor.userPostalCode = this.zipCode;
    this.distributor.userCity = this.city;
    this.distributorsService.saveDistributor(this.distributor).subscribe(
      ({ StatusCode, Message, Data }) =>
        Data != null
          ? this.handleSaveSuccess(Data)
          : this.handleSaveError(StatusCode),
      () => {
        this.ErrorMessage();
        this.clearFields();
      }
    );
  }

  handleSaveError(StatusCode: number) {
    this.ErrorMessage();
    this.clearFields();
  }

  async handleSaveSuccess(distributor: UserDTO) {
    if (distributor.userId === 0) {
      this.alert = {
        alertMessage: 'This user already exists',
        alertType: 'alert alert-warning',
        alertCenter: false,
        alerTitle: '',
        duration: 3000,
      };
      this.alertService.updateAlertState(this.alert);
    } else {
      this.alert = {
        alertMessage: 'Distributor saved successfully',
        alertType: 'alert alert-success',
        alertCenter: false,
        alerTitle: '',
        duration: 3000,
      };
      localStorage.setItem('AlertObject', JSON.stringify(this.alert));
      this.alertService.updateAlertState(this.alert);
      this.clearFields();
      location.reload();
    }
  }

  handleGetAllStatesSuccess(states: MasterDataDTO[]) {
    this.states = states;
  }

  clearFields() {}

  ErrorMessage() {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000,
    };
    this.alertService.updateAlertState(this.alert);
  }

  checkEmailValidity() {
    this.validMail = !!this.emailModel?.valid;
  }
}
